/* Native dialog supplies the top layer, modal focus containment and Escape handling. */
if (!customElements.get('runit-menu')) {
  customElements.define('runit-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-menu-open]');
      this.tabs = Array.from(this.querySelectorAll('[data-menu-tab]'));
      this.trigger.addEventListener('click', () => this.open(), options);
      this.trigger.addEventListener('pointerdown', () => this.warm(), options);
      this.querySelector('[data-menu-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => this.restore(), options);
      // Search runs in place through the store's <predictive-search> element wrapped around the form.
      // A click must both start and finish on the backdrop; dragging out of a control is safe.
      this.dialog.addEventListener('pointerdown', (event) => {
        this.backdropStart = this.outside(event);
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (this.backdropStart && this.outside(event)) this.dialog.close();
        this.backdropStart = false;
      }, options);
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectTab(tab), options);
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.selectTab(this.tabs[next]);
          this.tabs[next].focus();
        }, options);
      });
      this.querySelectorAll('details').forEach((details) => {
        const summary = details.querySelector(':scope > summary');
        const sync = () => summary.setAttribute('aria-expanded', String(details.open));
        sync();
        details.addEventListener('toggle', sync, options);
      });
    }
    outside(event) {
      const rect = this.dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right ||
        event.clientY < rect.top || event.clientY > rect.bottom;
    }
    open() {
      if (this.dialog.open) return;
      this.warm();
      if (this.tabs.length) this.selectTab(this.tabs[0]);
      this.dialog.scrollTop = 0;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
    }
    // Lazy images in the hidden CLUB tab only started loading on tab click; fetch them as the menu opens.
    warm() {
      this.dialog.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
    }
    selectTab(tab) {
      this.tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      this.querySelectorAll('[data-menu-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.menuPanel !== tab.dataset.menuTab;
      });
    }
    restore() {
      document.documentElement.style.overflow = this.previousOverflow ?? '';
      this.trigger.setAttribute('aria-expanded', 'false');
      if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        this.restore();
      }
      this.controller?.abort();
      this.controller = null;
    }
  });
}
